// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root variables for consistent theming */
:root {
  --color-primary: #6644CC;
  --color-accent-1: #FF6B6B;
  --color-accent-2: #28C76F;
  --color-text-dark: #333333;
  --color-text-light: #666666;
  --color-background-light: #F8F9FA;
  --color-card-background: #FFFFFF;
  --color-hover-light: #F0EBFF;
  --color-border: #E0E0E0;
}

/* Base styles for the main header */
.main-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  font-family: 'Poppins', sans-serif;
  border-radius: 0.75rem;
  margin: 0 1rem 0rem 1rem;
  /* padding: 0.75rem 1rem; */
}

/* Styles for icon buttons in the header */
.header-icon-button {
  padding: 0.5rem;
  border-radius: 9999px;
  background-color: var(--color-background-light);
  color: var(--color-text-light);
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-icon-button:hover {
  background-color: var(--color-hover-light);
  color: var(--color-primary);
  transform: scale(1.1);
}

/* User Avatar Circle */
.user-avatar-circle {
  width: 50px;
  height: 50px;
  background: linear-gradient(to bottom right, var(--color-primary), #a78bfa);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: var(--color-card-background);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Welcome Text */
.welcome-text {
  color: var(--color-text-dark);
  font-weight: 700;
}

.highlight-name {
  color: var(--color-primary);
  background: linear-gradient(to right, var(--color-primary), #a78bfa);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Search Input */
.search-input {
  padding: 0.65rem 1rem 0.65rem 2.5rem;
  border-radius: 9999px;
  border: 1px solid var(--color-border);
  background-color: var(--color-background-light);
  font-size: 0.9rem;
  color: var(--color-text-dark);
  transition: all 0.3s ease;
  width: 160px;
}

.search-input:focus,
.search-input.search-input-focused {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-primary) 20%, transparent);
  width: 200px;
}

/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background-color: var(--color-accent-1);
  border-radius: 9999px;
  border: 2px solid var(--color-card-background);
  animation: pulse 2s infinite;
}

/* Dropdown Menu (Notifications & Settings) */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  max-width: 280px;
  overflow: hidden;
  z-index: 60;
  padding: 0.5rem 0;
}

.dropdown-header {
  padding: 0.75rem 1rem;
  font-weight: 600;
  color: var(--color-text-dark);
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 0.5rem;
}

.dropdown-item,
.dropdown-item-text {
  display: block;
  padding: 0.75rem 1rem;
  color: var(--color-text-dark);
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dropdown-item:hover {
  background-color: var(--color-hover-light);
  color: var(--color-primary);
}

.dropdown-close-button,
.dropdown-logout-button {
  width: calc(100% - 2rem);
  margin: 0.5rem 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  text-align: center;
  display: block;
}

.dropdown-close-button {
  background-color: var(--color-background-light);
  color: var(--color-text-dark);
}

.dropdown-close-button:hover {
  background-color: var(--color-hover-light);
  transform: scale(1.02);
}

.dropdown-logout-button {
  background-color: var(--color-accent-1);
  color: var(--color-card-background);
}

.dropdown-logout-button:hover {
  background-color: color-mix(in srgb, var(--color-accent-1) 85%, black);
  transform: scale(1.02);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

.animate-bounce-subtle {
  animation: bounce 1.5s infinite alternate;
}

/* Responsive adjustments */
@media (min-width: 768px) {
  .main-header {
    padding: 0.75rem 1.5rem;
  }
  .search-input {
    width: 200px;
  }
  .search-input:focus,
  .search-input.search-input-focused {
    width: 250px;
  }
}

@media (min-width: 1024px) {
  .main-header {
    padding: 1rem 2rem;
  }
  .search-input {
    width: 240px;
  }
  .search-input:focus,
  .search-input.search-input-focused {
    width: 300px;
  }
}
.menu-btn {
  background: var(--bg-light);
  border: none;
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.menu-btn:hover {
  background: var(--primary);
  color: var(--white);
}

.icon {
  width: 24px;
  height: 24px;
  color: var(--text-dark);
}

@media (max-width: 767px) {
  .main-header {
    margin: 0 0.5rem 1rem 0.5rem;
    padding: 0.5rem;
  }
  .search-input {
    display: none; /* Hide search bar on mobile */
  }
  .welcome-text {
    font-size: 1rem;
  }
  .user-avatar-circle {
    width: 32px;
    height: 32px;
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/newtest/Header/Header.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,4CAA4C;EAC5C,yCAAyC;EACzC,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,qBAAqB;EACrB,+CAA+C;EAC/C,8BAA8B;EAC9B,4EAA4E;EAC5E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oEAAoE;EACpE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,qBAAqB;EACrB,qCAAqC;EACrC,+CAA+C;EAC/C,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,+EAA+E;EAC/E,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,qBAAqB;EACrB,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,sEAAsE;EACtE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;AACF;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,aAAa,EAAE,8BAA8B;EAC/C;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* Root variables for consistent theming */\n:root {\n  --color-primary: #6644CC;\n  --color-accent-1: #FF6B6B;\n  --color-accent-2: #28C76F;\n  --color-text-dark: #333333;\n  --color-text-light: #666666;\n  --color-background-light: #F8F9FA;\n  --color-card-background: #FFFFFF;\n  --color-hover-light: #F0EBFF;\n  --color-border: #E0E0E0;\n}\n\n/* Base styles for the main header */\n.main-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--color-border);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  font-family: 'Poppins', sans-serif;\n  border-radius: 0.75rem;\n  margin: 0 1rem 0rem 1rem;\n  /* padding: 0.75rem 1rem; */\n}\n\n/* Styles for icon buttons in the header */\n.header-icon-button {\n  padding: 0.5rem;\n  border-radius: 9999px;\n  background-color: var(--color-background-light);\n  color: var(--color-text-light);\n  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header-icon-button:hover {\n  background-color: var(--color-hover-light);\n  color: var(--color-primary);\n  transform: scale(1.1);\n}\n\n/* User Avatar Circle */\n.user-avatar-circle {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(to bottom right, var(--color-primary), #a78bfa);\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  color: var(--color-card-background);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Welcome Text */\n.welcome-text {\n  color: var(--color-text-dark);\n  font-weight: 700;\n}\n\n.highlight-name {\n  color: var(--color-primary);\n  background: linear-gradient(to right, var(--color-primary), #a78bfa);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Search Input */\n.search-input {\n  padding: 0.65rem 1rem 0.65rem 2.5rem;\n  border-radius: 9999px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-background-light);\n  font-size: 0.9rem;\n  color: var(--color-text-dark);\n  transition: all 0.3s ease;\n  width: 160px;\n}\n\n.search-input:focus,\n.search-input.search-input-focused {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-primary) 20%, transparent);\n  width: 200px;\n}\n\n/* Notification Badge */\n.notification-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 12px;\n  height: 12px;\n  background-color: var(--color-accent-1);\n  border-radius: 9999px;\n  border: 2px solid var(--color-card-background);\n  animation: pulse 2s infinite;\n}\n\n/* Dropdown Menu (Notifications & Settings) */\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-radius: 0.75rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  min-width: 220px;\n  max-width: 280px;\n  overflow: hidden;\n  z-index: 60;\n  padding: 0.5rem 0;\n}\n\n.dropdown-header {\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n  color: var(--color-text-dark);\n  border-bottom: 1px solid var(--color-border);\n  margin-bottom: 0.5rem;\n}\n\n.dropdown-item,\n.dropdown-item-text {\n  display: block;\n  padding: 0.75rem 1rem;\n  color: var(--color-text-dark);\n  text-decoration: none;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.dropdown-item:hover {\n  background-color: var(--color-hover-light);\n  color: var(--color-primary);\n}\n\n.dropdown-close-button,\n.dropdown-logout-button {\n  width: calc(100% - 2rem);\n  margin: 0.5rem 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  text-align: center;\n  display: block;\n}\n\n.dropdown-close-button {\n  background-color: var(--color-background-light);\n  color: var(--color-text-dark);\n}\n\n.dropdown-close-button:hover {\n  background-color: var(--color-hover-light);\n  transform: scale(1.02);\n}\n\n.dropdown-logout-button {\n  background-color: var(--color-accent-1);\n  color: var(--color-card-background);\n}\n\n.dropdown-logout-button:hover {\n  background-color: color-mix(in srgb, var(--color-accent-1) 85%, black);\n  transform: scale(1.02);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-3px);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.3s ease-out forwards;\n}\n\n.animate-bounce-subtle {\n  animation: bounce 1.5s infinite alternate;\n}\n\n/* Responsive adjustments */\n@media (min-width: 768px) {\n  .main-header {\n    padding: 0.75rem 1.5rem;\n  }\n  .search-input {\n    width: 200px;\n  }\n  .search-input:focus,\n  .search-input.search-input-focused {\n    width: 250px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .main-header {\n    padding: 1rem 2rem;\n  }\n  .search-input {\n    width: 240px;\n  }\n  .search-input:focus,\n  .search-input.search-input-focused {\n    width: 300px;\n  }\n}\n.menu-btn {\n  background: var(--bg-light);\n  border: none;\n  padding: 0.5rem;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.menu-btn:hover {\n  background: var(--primary);\n  color: var(--white);\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  color: var(--text-dark);\n}\n\n@media (max-width: 767px) {\n  .main-header {\n    margin: 0 0.5rem 1rem 0.5rem;\n    padding: 0.5rem;\n  }\n  .search-input {\n    display: none; /* Hide search bar on mobile */\n  }\n  .welcome-text {\n    font-size: 1rem;\n  }\n  .user-avatar-circle {\n    width: 32px;\n    height: 32px;\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
